import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "construction-worker-show" }
const _hoisted_2 = { class: "warning-red" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Bedrijf (contractpartij) / Company (contracting party)", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Bedrijfsnaam bouwplaatsmedewerker", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Voornaam / Firstname", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "Achternaam / Lastname", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Bouwplaatsmedewerker in dienst", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Adres / Address", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Postcode / Zipcode", -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Plaats / City", -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Geboortedatum / Date of birth", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "Nationaliteit / Nationality", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", null, "ID - Document type", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "ID - Land van uitgifte / Country of issue", -1)
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "ID - BSN / Personal identification number", -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", null, "ID - Documentnummer / Document number", -1)
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", null, "ID - Geldig tot / Date of expiry", -1)
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  class: "error"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", null, "Verblijfsvergunning / Residence permit", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Nederlandse werkvergunning / Dutch work permit", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "Werkvergunningsnummer / Work permit number", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", null, "Werkvergunning geldig tot / Work permit date of expiry", -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 1,
  class: "error"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", null, "VCA gecertificeerd / Certified", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", null, "VCA - Geldig tot / Date of expiry", -1)
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "error"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "In bezit van GPI / In possession of GPI", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", null, "GPI - Geldig tot / Date of expiry", -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = {
  key: 1,
  class: "error"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", null, "In bezit van PU certificaat / In possession of PU certificate", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", null, "PU - Geldig tot / Date of expiry", -1)
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 1,
  class: "error"
}

import { computed, onMounted, ref } from 'vue'
import axios from 'axios'
import { ConstructionWorker } from '@/types/constructionWorker'
import { useRoute, useRouter } from 'vue-router'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons-vue'
import { notification } from 'ant-design-vue'
import PageTitleBar from '@/components/PageTitleBar.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ConstructionWorkerShow',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const loading = ref(false)

const EERMember = computed(() => {
  return constructionWorker.value.EERMember
})

const constructionWorker = ref<ConstructionWorker>({
  company_id: null,
  company: null,
  is_subcontractor: false,
  subcontractor_company_name: null,
  firstname: null,
  lastname: null,
  address: null,
  street: null,
  housenumber: null,
  zipcode: null,
  city: null,
  date_of_birth: null,
  nationality_id: 92,
  nationality: null,
  document_type: 1,
  document_country_id: 92,
  country: null,
  EERMember: null,
  personal_identification_number: null,
  document_number: null,
  document_expiry_date: null,
  residence_permit: null,
  work_permit: null,
  work_permit_number: null,
  work_permit_expiry_date: null,
  vca_certified: 0,
  vca_expiry_date: null,
  gpi_certified: 0,
  gpi_expiry_date: null,
  pu_certified: 0,
  pu_expiry_date: null,
  portraitPhoto: [],
  idFront: [],
  idBack: [],
  permitFront: [],
  permitBack: [],
  signature: [],
  denied: {
    is_denied: false,
    denied_at: null,
    reason: null
  }
})

onMounted(() => {
  getConstructionWorker()
})

function getConstructionWorker () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/constructionWorkers/' + route.params.constructionWorkerId).then((r) => {
    constructionWorker.value = r.data.data
  }).catch(() => {
    notification.error({ message: 'Fout bij ophalen van medewerker!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.' })
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageTitleBar, null, {
      title: _withCtx(() => [
        _createTextVNode("Medewerker bekijken.")
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'ConstructionWorkerEdit', params: { constructionWorkerId: _unref(route).params.constructionWorkerId } })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Medewerker bewerken")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'ConstructionWorkers' })))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Terug naar overzicht")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: constructionWorker.value.firstname && constructionWorker.value.lastname ? constructionWorker.value.firstname + ' ' + constructionWorker.value.lastname : 'Bouwplaatsmedewerker',
              loading: loading.value
            }, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_3,
                        (constructionWorker.value.company)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(constructionWorker.value.company.name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.subcontractor_company_name)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_5,
                            (constructionWorker.value.subcontractor_company_name)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(constructionWorker.value.subcontractor_company_name), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        (constructionWorker.value.firstname)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(constructionWorker.value.firstname), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        (constructionWorker.value.lastname)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(constructionWorker.value.lastname), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_11,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.active,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((constructionWorker.value.active) = $event)),
                          disabled: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: false }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: true }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        (constructionWorker.value.address)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(constructionWorker.value.address), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_14,
                        (constructionWorker.value.zipcode)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(constructionWorker.value.zipcode), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        (constructionWorker.value.city)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(constructionWorker.value.city), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_18,
                        (constructionWorker.value.date_of_birth)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(new Date(constructionWorker.value.date_of_birth).toLocaleDateString('nl-NL')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_20,
                        (constructionWorker.value.nationality)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(constructionWorker.value.nationality.nationality), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_22,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.document_type,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((constructionWorker.value.document_type) = $event)),
                          disabled: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createTextVNode("ID-bewijs")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 2 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Paspoort")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 3 }, {
                              default: _withCtx(() => [
                                _createTextVNode("Rijbewijs")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_23,
                        (constructionWorker.value.country)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(constructionWorker.value.country.name), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_25,
                        (constructionWorker.value.personal_identification_number)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(constructionWorker.value.personal_identification_number), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_27,
                        (constructionWorker.value.document_number)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_28, _toDisplayString(constructionWorker.value.document_number), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_29,
                        (constructionWorker.value.document_expiry_date)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(new Date(constructionWorker.value.document_expiry_date).toLocaleDateString('nl-NL')), 1))
                          : _createCommentVNode("", true),
                        (constructionWorker.value.document_expiry_date && new Date() > new Date(constructionWorker.value.document_expiry_date))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, "ID - verlopen / expired!"))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_unref(EERMember))
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_32,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: constructionWorker.value.residence_permit,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((constructionWorker.value.residence_permit) = $event)),
                              disabled: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.residence_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_33,
                            _createVNode(_component_a_radio_group, {
                              "button-style": "solid",
                              value: constructionWorker.value.work_permit,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((constructionWorker.value.work_permit) = $event)),
                              disabled: true
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_radio_button, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CloseOutlined))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_radio_button, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CheckOutlined))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.work_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_34,
                            (constructionWorker.value.work_permit_number)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(constructionWorker.value.work_permit_number), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_unref(EERMember) && constructionWorker.value.work_permit)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_36,
                            (constructionWorker.value.work_permit_expiry_date)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(new Date(constructionWorker.value.work_permit_expiry_date).toLocaleDateString('nl-NL')), 1))
                              : _createCommentVNode("", true),
                            (constructionWorker.value.work_permit_expiry_date && new Date() > new Date(constructionWorker.value.work_permit_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Werkvergunning verlopen / Work permit expired!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_39,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.vca_certified,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((constructionWorker.value.vca_certified) = $event)),
                          disabled: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.vca_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 5 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_40,
                            (constructionWorker.value.vca_expiry_date)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(new Date(constructionWorker.value.vca_expiry_date).toLocaleDateString('nl-NL')), 1))
                              : _createCommentVNode("", true),
                            (constructionWorker.value.vca_expiry_date && new Date() > new Date(constructionWorker.value.vca_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_42, "VCA verlopen / VCA expired!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_43,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.gpi_certified,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((constructionWorker.value.gpi_certified) = $event)),
                          disabled: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.gpi_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 6 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_44,
                            (constructionWorker.value.gpi_expiry_date)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(new Date(constructionWorker.value.gpi_expiry_date).toLocaleDateString('nl-NL')), 1))
                              : _createCommentVNode("", true),
                            (constructionWorker.value.gpi_expiry_date && new Date() > new Date(constructionWorker.value.gpi_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_46, "GPI verlopen / GPI expired!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _hoisted_47,
                        _createVNode(_component_a_radio_group, {
                          "button-style": "solid",
                          value: constructionWorker.value.pu_certified,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((constructionWorker.value.pu_certified) = $event)),
                          disabled: true
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_radio_button, { value: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CloseOutlined))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_radio_button, { value: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CheckOutlined))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (constructionWorker.value.pu_certified)
                  ? (_openBlock(), _createBlock(_component_a_row, { key: 7 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _hoisted_48,
                            (constructionWorker.value.pu_expiry_date)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_49, _toDisplayString(new Date(constructionWorker.value.pu_expiry_date).toLocaleDateString('nl-NL')), 1))
                              : _createCommentVNode("", true),
                            (constructionWorker.value.pu_expiry_date && new Date() > new Date(constructionWorker.value.pu_expiry_date))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50, "PU verlopen / PU expired!"))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (constructionWorker.value.denied.is_denied)
                ? {
                    name: "extra",
                    fn: _withCtx(() => [
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "text-right"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_2, "Let op! Deze bouwplaatsmedewerker is geweigerd! (Sinds " + _toDisplayString(new Date(constructionWorker.value.denied.denied_at).toLocaleDateString('nl-NL')) + ")", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["title", "loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})